import { render, staticRenderFns } from "./monthIncomeSummary.vue?vue&type=template&id=c24e45e4&scoped=true&"
import script from "./monthIncomeSummary.vue?vue&type=script&lang=js&"
export * from "./monthIncomeSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24e45e4",
  null
  
)

export default component.exports